define('appkit/util/key.prefixer',['require','exports','module','underscore'],function(require, exports, module) {
  var _ = require('underscore');

  exports.hasPrefix = function(value, prefix) {
    return String(value).indexOf(prefix) === 0;
  };

  exports.removePrefix = function(value, prefix) {

    return String(value).slice(String(prefix || '').length);
  };

  exports.resolve = function(keyValueObject, valueResolvers, context) {
    var finalObject = {},
        prefixes    = _.keys(valueResolvers);

    _.each(keyValueObject, function(value, key) {
      var valueResolver, prefix;

      // find the correct prefix
      prefix = _.find(prefixes, function(prefix) {
        return exports.hasPrefix(value, prefix);
      });

      if (prefix) {
        valueResolver = valueResolvers[prefix];
      }

      if (_.isFunction(valueResolver)) {
        finalObject[key] = valueResolver.call(context || this, exports.removePrefix(value, prefix), key, value);
      } else {
        finalObject[key] = value;
      }

    });

    return finalObject;
  };

});
